export const ActionType = {
  SET_IS_VISIBLE_SIGN_IN_MODAL: 'setIsVisibleSignInModal',
  SET_IS_VISIBLE_SIGN_UP_MODAL: 'setIsVisibleSignUpModal',
  SET_IS_VISIBLE_WAIT_MODAL: 'setIsVisibleWaitModal',
  SET_SET_ERROR_MESSAGES: 'setErrorMessages',
  SET_IS_AUTHENTICATED: 'setIsAuthenticated',
  SET_BIRTHDAYS: 'setBirthdays',
  SET_CURRENT_USER: 'setCurrentUser',
  SET_BIRTHDAY: 'setBirthday',
  SET_PROFILE_IMAGE: 'setProfileImage',
  SET_PREVIEW_PROFILE_IMAGE: 'setPreviewProfileImage',
  SET_BIRTHDAY_IMAGE: 'setBirthdayImage',
  SET_PREVIEW_BIRTHDAY_IMAGE: 'setPreviewBirthdayImage',
  SET_IS_PROFILE_INFO_MODE: 'setIsProfileInfoMode',
  SET_IS_BIRTHDAY_INFO_MODE: 'setIsBirthdayInfoMode',
  IS_DARK_MODE: 'setIsDarkMode',
  SET_QUERY: 'setQuery',
};
